import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../app/store';

export type WifiConfigState = {
  bearerToken: string | null;
  isEditing: boolean;
};

const initialState: WifiConfigState = {
  bearerToken: null,
  isEditing: false,
};

export const wifiConfigSlice = createSlice({
  name: 'wifiConfig',
  initialState,
  reducers: {
    addBearerToken: (state, action: PayloadAction<string>) => {
      return { ...state, bearerToken: action.payload };
    },
    resetWifiConfig: () => {
      return { ...initialState };
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      return { ...state, isEditing: action.payload };
    },
  },
});

export const { resetWifiConfig, addBearerToken, setIsEditing } = wifiConfigSlice.actions;

export const selectWifiConfigState = (state: RootState) => {
  return state.wifiConfig;
};

export const { reducer: wifiConfigReducer } = wifiConfigSlice;
